module.exports = __webpack_public_path__ + "img/SES_190410001.40e4effd.jpg";